/**
 * en-GB messages added by Phase 3 task S35 (docs/PHASE-3-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const s35EnGB = {
    'error.remote_site_no_display': 'A remote site cannot have a reception display.',
    'error.display_code_invalid': 'That code was not recognised. Check the number on the screen and try again.',
    'error.display_not_found': 'That display was not found.',
    'display.unnamed': 'Reception display',
};
//# sourceMappingURL=s35.js.map